<div class="row">
  How long should it take?
  <task-duration-slider
    [control]="$any(form.get('duration'))"
    durationDisplayType="manualTask"
    [lightBackground]="newTask"
  ></task-duration-slider>
</div>
@if (!isTemplate) {
  <div class="row">
    Reward
    <task-dialog-details-panel-rewards [form]="$any(form)" [newTask]="newTask"></task-dialog-details-panel-rewards>
  </div>
  <div class="row">
    Priority
    <task-priority-selector [control]="$any(form.get('priority'))" [lightBackground]="newTask"></task-priority-selector>
  </div>

  <div class="assignments-container" [class.task-item-variable-bg]="!newTask">
    <provisions-selector
      [newTask]="newTask"
      [form]="form"
      [teamsMap]="teamsMap$ | async"
      [usersMap]="usersMap$ | async"
      [skillsMap]="skillsMap$ | async"
      (panelChange)="onChangePanel(ProjectTaskDialogPanels.Assignments)"
    ></provisions-selector>
  </div>

  @if (newTask) {
    <div
      class="checkbox-wrapper"
      [class.disabled-with-tooltip]="scheduleControl.get('scheduleType').value !== 'doNotRepeat'"
      [matTooltip]="scheduleControl.get('scheduleType').value !== 'doNotRepeat' ? 'Only for non-repeating task' : ''"
      matTooltipPosition="below"
    >
      <oph-checkbox
        [control]="$any(this.form.get('deleteWhenComplete'))"
        [width]="25"
        textOrientation="right"
        text="Delete task when complete"
        [textStyle]="{
          color: 'var(--Ophanim-Final-Off-black, #4A443D)',
          'font-family': 'Asap',
          'font-size': '15px',
          'font-style': 'normal',
          'font-weight': '400'
        }"
        color="green"
      ></oph-checkbox>
    </div>
  }
}
